import RecessAPI from './RecessAPI'

class AuthService

  @login: (data) ->
    { item: member, errors } = await RecessAPI.authenticate { login: data }
    throw errors if errors?
    member

  @register: (data) ->
    { social_presence, top_org, tos } = data
    payload = { social_presence, top_org, tos }
    { item: member, errors } = await RecessAPI.signup social_presence.market_type, payload
    error = errors[Object.keys(errors)[0]] if errors?
    throw error if error
    member

export default AuthService